import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Elevation, Grid, GridCell, Button, Typography, Icon } from 'rmwc';
import { LoadingBar } from '../../components/util/LoadingBar';
import { currencyFormatter, Money } from '../../components/Money';

import { runFullSimulation } from '../../actions/simulationActions';
import { Text } from '../../components/Text';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';

import LetterScore from '../../components/charts/LetterScore';
import AssetBalanceChart from '../../components/charts/AssetBalanceChart';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchSavingsModule } from '../../actions/savingsActions';
import { updateScoreFromSimulations } from '../../actions/toolsActions';

import { wlVar } from '../../helpers/whitelabel';

import InvestmentFeesSidebar from './InvestmentFeesSidebar';

import { CTAOpt } from '../../components/Onboarding/CtaVariants';
import {
  MTHeader,
  MTSkinny,
  MTSubheading,
  MTSubcontent,
  MTSubcontentP,
  MTDivider,
  MTSubcontentHR,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentLabel,
  MTScorePanel,
  MTCTAv2,
  MTLearnMore,
  MTLearnMoreItem,
} from './layout';
import { wlPath } from '../../helpers/whitelabel';

export class InvestmentFees extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }
    this.fetchData();
  }

  fetchData = () => {
    this.props.fetchSavingsModule();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.updatedResults) {
      if (
        !this.props.updatedResults ||
        nextProps.updatedResults.scores.retirement_spending_power !=
          this.props.updatedResults.scores.retirement_spending_power
      ) {
        const { updateScoreFromSimulations } = this.props;
        updateScoreFromSimulations('Fee Savings', nextProps.jobs, nextProps.results, nextProps.updatedResults);
      }
    }
  }

  calcRetirementFeeSaving = () => {
    if (this.props.updatedResults && this.props.people) {
      const primaryAge = this.props.people[0].age;
      const retirementAge = 67;
      const yearsUntilRetirement = retirementAge - primaryAge;
      // person already retired
      if (yearsUntilRetirement <= 0) {
        return 0;
      }
      const savingsAmount =
        this.props.results.distribution.asset_balance.average[yearsUntilRetirement - 1] -
        this.props.updatedResults.distribution.asset_balance.average[yearsUntilRetirement - 1];
      return savingsAmount;
    }
    return 0;
  };

  render() {
    const { people, results, onContinue, openRegistrationDialog, openEmailDialog, history, savings } = this.props;

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    if (!results || !savings) {
      return <LoadingBar />;
    }
    return (
      <div>
        <MTHeader title="Check your investment fund expenses" onClick={() => history.push(wlPath('/action-plan'))} />
        <MTSkinny>
          <MTSubheading title="What are fund expenses? Why do they matter?" />
          <MTSubcontent noCard>
            <MTSubcontentP>
              When you buy an investment fund, you are paying a fee to the company that manages that fund (Vanguard,
              Fidelity). These expenses can vary a lot, but{' '}
              <a
                href="https://www.barrons.com/articles/for-funds-high-fees-often-come-with-poor-performance-morningstar-1422549837"
                target="_blank"
              >
                higher fees are almost always worse for you.
              </a>
            </MTSubcontentP>
            <MTSubcontentP last>
              <strong>Most of the time, you’re better off using the cheapest fund, and saving.</strong>
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="How much could fund expenses impact your retirement?" />
          <MTSubcontent>
            <MTSubcontentH1 title="Fund expense impact calculator" />
            <MTSubcontentLabel>Set slider to the average investment expense of the funds you own.</MTSubcontentLabel>
            <InvestmentFeesSidebar />
            <MTSubcontentHR />
            <MTSubcontentH2 title="Your total net worth" />
            <AssetBalanceChart
              initial={this.props.results}
              updated={this.props.updatedResults}
              primaryPerson={this.props.primaryPerson}
              beforeLegend="Net Worth With Average Funds"
              afterLegend="Net Worth With Chosen Funds"
              useAfterLine
            />

          </MTSubcontent>
          <Text use="caption" className="text-muted">
            These calculators are designed to be informational and educational tools only, and when used alone, do not constitute investment advice. We strongly recommend that you seek the advice of a financial services professional before making any type of investment. We also encourage you to review your investment strategy periodically as your financial circumstances change. This model is provided as a rough approximation of future financial performance. The results presented by this calculator are hypothetical and may not reflect the actual growth of any investments. {wlVar('brand_name')} is not responsible for the consequences of any decisions or actions taken in reliance upon or as a result of the information provided by these tools.
          </Text>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="How do you start saving more on fund expenses?" />
          <MTCTAv2
            title="Want help getting started? Get a free fee analysis."
            subtitle="Take just 15 minutes to save $30,000."
            image={require('images/outcome-fees.png')}
            description="We'll start by getting a little more information from you. Then, our team will analyze your current funds to see if you have an opportunity to save on fees."
            buttonTextSecondary="Save for Later"
            onClickSecondary={() =>
              this.props.openRegistrationDialog(() => (window.location = '/start'), () => {}, 'SAVE_AND_REVISIT')
            }
            buttonTextPrimary="Learn More"
            onClickPrimary={() => this.props.history.push(`/start/investment-fees/analysis`)}
            talkingPointsHeading="Get started with these first steps"
            talkingPointsSubheading="Here are some tips to get you started"
            talkingPointsImage={require('images/icon-situation')}
            talkingPoints={[
              {
                image: require('images/outcome-fees.png'),
                label: 'Estimate how much fees are costing you.',
                text: (
                  <div className="p-3">
                    <Text use="body1" tag="p" className="pb-1">
                      The first step is to figure out the expense ratios of the funds that you currently own. You’ll
                      need to look at all of your accounts and take note of the fund symbol (or “Ticker”) for all the
                      funds in your account, and approximately how much you’ve invested in that asset.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      When people think of “investment fees,” they usually think of trading commissions and account
                      service fees—expenses you see directly subtracted from your accounts.{' '}
                      <strong>Investment fees</strong> (also referred to as an “<strong>Expense Ratio</strong>”) are
                      harder to find because they're not itemized on your account statements or confirmations. Instead,
                      these expenses are deducted from the fund itself, on a regular basis.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      To find the <strong>Expense Ratio</strong>, you can use a tool like{' '}
                      <a href="https://tools.finra.org/fund_analyzer/" target="_blank">
                        FINRA’s Fund Analyzer
                      </a>{' '}
                      to look up your fund, and see what the fees are. If you can’t find the fund using that tool, you
                      may have to search for it in the fund prospectus, the statement you get in the mail (or online)
                      for every fund you own.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      The expense ratio is usually a percentage, like 0.6%. That means if you’ve invested $100,000 in
                      that fund, you’re paying $600/year ($100,000 x 0.60%) in expenses. If you do a similar calculation
                      for all your investments, you’ll have a good sense for how much you’re paying to have someone
                      manage your money!
                    </Text>
                    <Text use="body1" tag="p" className="pb-1" style={{ fontStyle: 'italic' }}>
                      Other resources you might like
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      <a href="http://www.morningstar.com/InvGlossary/expense_ratio.aspx" target="_blank">
                        Expense Ratios: Definition and Explanation by Morningstar
                      </a>
                    </Text>
                  </div>
                ),
              },
              {
                image: require('images/icon-questions.png'),
                label: 'How to decide if a fund is worth a higher fee or not.',
                text: (
                  <div className="p-3">
                    <Text use="body1" tag="p" className="pb-1">
                      Deciding if high fund fees are “worth it” requires understanding why the fees are high, and if
                      that’s something you’re willing to pay for.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      There are two factors that determine how expensive an investment fund is:
                    </Text>
                    <ol>
                      <Text use="body1" tag="li" className="pb-0">
                        The fund’s category is generally expensive (eg. international stocks)
                      </Text>
                      <Text use="body1" tag="li" className="pb-0">
                        The fund has high fees even relative to other funds with the same category
                      </Text>
                    </ol>
                    <Text use="body1" tag="p" className="pb-1">
                      (See:{' '}
                      <strong>
                        <span
                          style={{ color: '#10cf9b', cursor: 'pointer' }}
                          onClick={() => document.getElementById('learn-more-section').scrollIntoView()}
                        >
                          Why are some fees higher than others?
                        </span>
                      </strong>)
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      The chart below shows the average expense ratio for various fund types
                    </Text>
                    <iframe
                      className="mb-2"
                      src="https://e.infogram.com/mutual_fund_expense_ratios-5?src=embed"
                      title="Mutual fund expense ratios"
                      width="550"
                      height="750"
                      scrolling="no"
                      frameBorder="0"
                      style={{ border: 'none' }}
                      allowFullScreen="allowfullscreen"
                    />
                    <Text use="body1" tag="p" className="pb-1">
                      As a general rule of thumb, if you know you want a specific investment category, then it might be
                      worth paying a higher fee for those funds, even if the category as a whole is more expensive.
                      Within a given category, it’s generally best to buy the cheapest option available because, within
                      a specific funds with higher fees tend to{' '}
                      <a href="http://news.morningstar.com/articlenet/article.aspx?id=752485" target="blank">
                        perform worse once fees are taken into account
                      </a>.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      <strong>
                        Ultimately there’s no one-size-fits all answer that works for everyone. If you’re not sure what
                        investment categories you should be willing to pay for, or if you want help picking lower-cost
                        funds within a category, you might benefit from a complimentary investment fee analysis with one of our
                        advisors.
                      </strong>
                    </Text>
                  </div>
                ),
              },
              {
                image: require('images/icon-options.png'),
                label: 'What to do if your account only offers expensive funds?',
                text: (
                  <div className="p-3">
                    <Text use="body1" tag="p" className="pb-1">
                      Oftentimes, if you have savings in an employer-sponsored plan (401k, 403b, 457), you will only
                      have a limited “menu” of investments to choose from. As a result, you might not really have a
                      low-cost option available to you. What you can do about this will vary depending on your exact
                      situation.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      Most plans will offer investment funds that don’t offer exactly the same strategy, but can be
                      substantially lower cost. The simplest option is to move more of your money into these funds, but
                      this can be hard to do without affecting your investment outcome.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      Another alternative is to roll over your account balance into an Individual Retirement Account
                      (IRA). IRAs give you a lot more options with the types of investments you can own. Contrary to popular belief, you don’t have to wait until you’ve left your employer before
                      rolling over. There can be drawbacks, but this can be outweighed if your plan offers limited
                      options, and those investment fees are costing you $100,000 by retirement.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      A final option is to get a “<a
                        href="https://www.investopedia.com/terms/b/brokerage_window.asp"
                        target="_blank"
                      >
                        brokerage window
                      </a>” in your 401k plan. This gives you complete flexibility to buy and sell investment securities
                      such as low-cost ETFs without any restrictions. It effectively turns your 401k into a regular
                      investment account. However, this option is not suitable for everyone: some employers don’t offer
                      access, and it can be risky if you are not{' '}
                      <a
                        href="http://www.finra.org/investors/dont-open-401k-brokerage-window-you-learn-these-3-things"
                        target="_blank"
                      >
                        100% confident in your investment strategy
                      </a>.
                    </Text>
                    <Text use="body1" tag="p" className="pb-1">
                      <strong>
                        Whichever path you take, it’s usually a good idea to consult with a financial professional before
                        making any of these changes. The savings from fees can be huge, but you want to make sure you’re
                        not giving up anything else by doing so.
                      </strong>
                    </Text>
                  </div>
                ),
              },
            ]}
          />
        </MTSkinny>
        <MTDivider className="mt-0" />
        <MTSkinny>
          <MTSubheading title="Learn more" />
          <div id="learn-more-section">
            <MTLearnMore>
              <MTLearnMoreItem title="What are investment fund fees and why do they exist?">
                <Text use="body1" tag="p" className="pb-1">
                  Investment fund fees are fees paid for "hiring" a company to invest your money for you in a certain
                  way. They exist to pay the salaries of the people picking the individual stocks and bonds into which
                  your money is invested and to pay for the operating costs of the fund such as technology, trading, and
                  compliance costs.
                </Text>
              </MTLearnMoreItem>
              <MTLearnMoreItem title="Why are some fees higher than others?">
                <Text use="body1" tag="p" className="pb-1">
                  In general, there are two things that could make the fees for an investment fund higher:
                </Text>
                <Text use="body1" tag="p" className="pb-1" style={{ fontStyle: 'italic' }}>
                  The fund “category” is generally expensive.
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  Investment funds each have their own strategy, designed to help their investors accomplish some
                  specific objective. The differences between strategies could include: different asset classes;
                  frequency of trading; whether they are{' '}
                  <a href="https://www.investopedia.com/news/active-vs-passive-investing/" target="_blank">
                    active or passive
                  </a>; and so on.
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  The reason this matters is that some strategies are intrinsically more expensive than others. For
                  example, international equity funds are more expensive because it generally costs more to trade in
                  international markets than in more efficient US markets.
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  The chart below shows the average expense ratio for various fund types
                </Text>
                <iframe
                  className="mb-2"
                  src="https://e.infogram.com/mutual_fund_expense_ratios-5?src=embed"
                  title="Mutual fund expense ratios"
                  width="550"
                  height="650"
                  scrolling="no"
                  frameBorder="0"
                  style={{ border: 'none' }}
                  allowFullScreen="allowfullscreen"
                />
                <Text use="body1" tag="p" className="pb-1">
                  You may be willing to pay a higher investment fee if you have <strong>a specific strategy</strong>{' '}
                  that you need (getting access to international markets), and funds with that strategy are generally
                  more expensive.
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  Just remember that you don’t need to have every strategy in your portfolio. So before you spend up big
                  for a “hybrid mutual fund” you should have a good idea for how it’s helping you accomplish your goals.
                </Text>
                <Text use="body1" tag="p" className="pb-1" style={{ fontStyle: 'italic' }}>
                  The fund is expensive even within its category.
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  This is where you need to pay close attention. There are a few reasons why a fund might be more
                  expensive than other funds that have the same broad strategy. One is performance: a certain fund might
                  do fairly well compared to similar funds, so they are able to charge more, because they are in greater
                  demand.Others charge more because they believe they devote more time and care into making investments
                  for you and believe they somehow have a unique strategy than other funds.
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  The size of company also matters. A bigger company with simpler funds usually charges you less,
                  because they have many more customers. Smaller companies usually have to charge more to stay in
                  business, but often offer a more unique fund in return.
                </Text>
              </MTLearnMoreItem>

              <MTLearnMoreItem title="Where do I look to see the fees I am currently paying today?">
                <Text use="body1" tag="p" className="pb-1">
                  You can look in the prospectus of any fund in which you are invested and it will tell you the fees
                  that are charged. However, you won’t see this fee withdrawn in an obvious way. It is usually withdrawn
                  net of your investment fees, so you don't see the specific amount you paid unless you examine closely.
                  You can also use a financial professional to help you determine how much you are paying.
                </Text>
                <Text use="body1" tag="p" className="pb-1" style={{ fontStyle: 'italic' }}>
                  Other resources you might like
                </Text>
                <Text use="body1" tag="p" className="pb-1">
                  <a href="http://www.morningstar.com/InvGlossary/expense_ratio.aspx" target="_blank">
                    Expense Ratios: Definition and Explanation by Morningstar
                  </a>
                </Text>
              </MTLearnMoreItem>
            </MTLearnMore>
          </div>
        </MTSkinny>
      </div>
    );
  }
}

function getPrimaryPerson(people, dashboard) {
  if (!people.fetched || !dashboard.fetched) {
    return null;
  }
  for (const person of people.data) {
    if (person.id == dashboard.data.primary_person_id) {
      return person;
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    people: state.people.data,
    results: state.simulations.results,
    primaryPerson: getPrimaryPerson(state.people, state.modules.dashboard),
    updatedResults: state.modules.dashboard.simulation ? state.modules.dashboard.simulation.results : null,
    savings: state.modules.savings.data,
    jobs: state.modules.jobs.data,
  };
}

function mapDispatchToProps() {
  return {
    runFullSimulation,
    fetchDashboard,
    fetchSavingsModule,
    updateScoreFromSimulations,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(withEmailDialog(withRegistrationDialog(InvestmentFees)));
